module.exports = __webpack_public_path__ + "img/pic2.3485da2a.png";